import { render, staticRenderFns } from "./Sp16Banner.vue?vue&type=template&id=eddb063c&scoped=true&"
import script from "./Sp16Banner.vue?vue&type=script&lang=js&"
export * from "./Sp16Banner.vue?vue&type=script&lang=js&"
import style0 from "./Sp16Banner.vue?vue&type=style&index=0&id=eddb063c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb063c",
  null
  
)

export default component.exports